import React from 'react';
import { _ } from '_locales';
import styled, { keyframes } from 'styled-components';
import { useHistory } from 'react-router-dom';
import * as actions from '_actions';
import { connect } from 'react-redux';

const OpacityAnimation = keyframes`
  from { opacity: 0;}
  to { opacity:1;}
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #72888E;
  color: #fff;
  margin: 20px 5px;
  border-radius: 10px;
  font-weight: 500;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  animation: ${OpacityAnimation} 0.5s;
  animation-delay: 0.7s;
  opacity: 0;
  animation-fill-mode: forwards;
`;

const Message = styled.p`
  color: #fff;
  padding: 10px 0;
  padding-left: 25px;

  & > span {
    color: #fff;
    cursor: pointer;
    margin-left: 7px;
    text-transform: uppercase !important;
    text-decoration: underline !important;
  }
`;

const Close = styled.div`
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  padding: 10px 25px;
`;

const CustomMessage = ({ url, showNationalSurveyPrompt, setShowNationalSurveyPropmt }) => {
  const history = useHistory();

  return (
    <>
      {showNationalSurveyPrompt && (
        <MessageContainer>
          <Message>
            {/* {_('general.participate_national_survey')} */}
            Do you know how to recycle right? Put your knowledge to the test with our Annual Survey!
            <span
              role="button"
              tabIndex={0}
              onKeyPress={() => history.push({
                pathname: '/campaign',
                state: { url }
              })}
              onClick={() => history.push({
                pathname: '/campaign',
                state: { url }
              })}
            >
              START NOW
              {/* {_('general.click_here')} */}
            </span>
          </Message>
          <Close onClick={() => setShowNationalSurveyPropmt(false)}>&#120;</Close>
        </MessageContainer>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  showNationalSurveyPrompt: state.alert.showNationalSurveyPrompt
});

const mapDispatchToProps = (dispatch) => ({
  setShowNationalSurveyPropmt:
    (showNationalSurveyPropmt) => dispatch(
      actions.alert.setShowNationalSurveyPropmt(showNationalSurveyPropmt)
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomMessage);
